module.exports = __webpack_public_path__ + "img/desktop1.3c76b9d7.png";